import { createAsyncThunk } from "@reduxjs/toolkit";

import { editNestedIterableItem } from "core/iterable_utils";
import { setMeta, setTree } from "slices/project_work";

export const applyValidToProjectTreeRow = createAsyncThunk(
	"estimateViewer/applyValidToProjectTreeRow",
	async ({ status, treeRows }, { extra, getState, rejectWithValue, dispatch }) => {
		const state = getState();

		const projectId = state.projectWork.main.id;
		const projectTreeSelected = treeRows;
		const projectTree = state.projectWork.tree;
		const projectMeta = state.projectWork.meta;

		const seletedKeys = projectTreeSelected.map((x) => x.key);

		const { editedIterable } = editNestedIterableItem({
			iterable: projectTree,
			isSeekRowCallback: (row) => seletedKeys?.includes(row.key),
			applyCallback: (row) => {
				row.expert_handle_valid = status;
			},
			breakAfterFirstMatch: false,
		});
		dispatch(setTree(editedIterable));

		const body = [];

		for (let estm of projectTreeSelected) {
			if (estm.type === "local") {
				body.push({
					project_id: projectId,
					estm_id: estm.id,
					model_name: estm.type,
					key: estm.key,
					status: status,
				});
			}
		}

		try {
			const { data } = await extra.apiProjects.setHandleExpertStatus({ body });
			dispatch(setMeta({ ...projectMeta, ...data }));

			if (!data) throw new Error();

			return data;
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);
